import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import routes from 'app/routes';

export default function Footer({ method }) {
  let url;

  switch (method) {
    case 'hr-system':
      url = routes.managers.members.hrSystem.index;
      break;
    case 'manual':
      url = routes.managers.members.manual;
      break;
    case 'file':
      url = routes.managers.members.file;
      break;
    default:
      url = routes.managers.members.manual;
  }

  return (
    <footer>
      <Link
        to={routes.managers.members.index}
        className="btn btn-outline-primary"
      >
        Cancel
      </Link>

      <Link
        to={url}
        className={`btn btn-primary ${method === null ? 'disabled' : ''}`}
      >
        Continue
      </Link>
    </footer>
  );
}

Footer.propTypes = {
  method: PropTypes.string,
};

Footer.defaultProps = {
  method: null,
};
